import React from 'react';
import { motion } from 'framer-motion';

const LogoCarousel = () => {
  const developers = [
    { name: 'EMAAR', logo: 'https://customer-assets.emergentagent.com/job_nava-dubai-wealth/artifacts/tx895ha9_Developer%20EMMAR.png' },
    { name: 'DAMAC', logo: 'https://customer-assets.emergentagent.com/job_nava-dubai-wealth/artifacts/087dst21_Developer%20DAMAC.png' },
    { name: 'NAKHEEL', logo: 'https://customer-assets.emergentagent.com/job_nava-dubai-wealth/artifacts/0o3vhxmo_DEVELOPER%20%20NAKHEEL.png' },
    { name: 'AZIZI', logo: 'https://customer-assets.emergentagent.com/job_nava-dubai-wealth/artifacts/ecxlmsa8_Developer%20AZIZI.png' },
    { name: 'BINGHATTI', logo: 'https://customer-assets.emergentagent.com/job_nava-dubai-wealth/artifacts/v95zrdaf_DEVELOPER%20%20BINGHATTI.png' },
    { name: 'DANUBE', logo: 'https://customer-assets.emergentagent.com/job_nava-dubai-wealth/artifacts/51z1uv2t_Developer%20Danube.png' },
    { name: 'ARADA', logo: 'https://customer-assets.emergentagent.com/job_nava-dubai-wealth/artifacts/1xp82dq1_DEVELOPER%20ARADA.png' },
    { name: 'DUBAI SOUTH', logo: 'https://customer-assets.emergentagent.com/job_nava-dubai-wealth/artifacts/50927sz2_DEVELOPER%20DUBAI%20SOUTH.png' },
  ];

  // Duplicate for seamless loop
  const allLogos = [...developers, ...developers, ...developers];

  return (
    <section className="relative py-12 overflow-hidden bg-gradient-to-br from-[#FFF8DC] to-[#F5F5DC]">
      <div className="container mx-auto px-6 mb-8">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
            Trusted By Industry Leaders
          </h2>
          <p className="text-gray-600">Partnered with Dubai's most prestigious developers</p>
        </motion.div>
      </div>

      {/* Auto-scrolling logo ribbon */}
      <div className="relative overflow-hidden py-8 bg-white">
        <motion.div
          className="flex gap-16 items-center"
          animate={{
            x: ['-33.333%', '0%'],
          }}
          transition={{
            x: {
              duration: 30,
              repeat: Infinity,
              ease: "linear",
            },
          }}
        >
          {allLogos.map((developer, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-40 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
            >
              <img
                src={developer.logo}
                alt={developer.name}
                className="max-w-full max-h-full object-contain"
              />
            </div>
          ))}
        </motion.div>

        {/* Gradient overlays for fade effect */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent pointer-events-none" />
      </div>

      {/* 100% Verified Projects badge */}
      <motion.div
        className="absolute top-8 right-8 px-6 py-3 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full shadow-lg"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3 }}
        whileHover={{ scale: 1.05 }}
      >
        <p className="text-sm font-bold text-gray-900">✓ 100% Verified Projects</p>
      </motion.div>
    </section>
  );
};

export default LogoCarousel;